import { getDomainUrl } from 'constants/urls';

export const regexToString = (regex: RegExp): string => new RegExp(regex).toString();

export const iamUrl = () => {
    const IAMUrl = `${getDomainUrl()}/iam`;
    return IAMUrl;
};